// Aslanpart Automotive - Dawn Media Gallery Stub
// Product gallery is now handled by the dedicated, high-performance ap-gallery component in snippets/product-media-gallery.liquid.
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
    }
  });
}
